<!-- 404 -->
<template>
  <div id="error">
    <div class="error-wrap">
      <img src="@/assets/img/notfound.png" class="error-img" alt="404" />
      <div class="error-r">
        <p class="error-tit">404</p>
        <p class="error-desc">抱歉，你访问的页面不存在</p>
        <router-link to="/" class="error-link" title="锐仕校园-首页"
          >返回首页</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {},
};
</script>
<style scoped>
#error {
  padding: 200px 0 350px;
  width: 100%;
  text-align: center;
  height: calc(100% - 288px);
  font-size: 36px;
  background: #fff;
}
.error-wrap {
  display: flex;
  justify-content: center;
}
.error-img {
  width: 302px;
  height: 186px;
}
.error-r {
  margin-left: 36px;
  padding: 20px 0;
}
.error-tit {
  font-size: 50px;
  font-weight: 500;
  color: #333333;
  line-height: 64px;
}
.error-desc {
  font-size: 16px;
  color: #999999;
  line-height: 24px;
  padding: 6px 0 15px;
}
.error-link {
  display: block;
  width: 88px;
  height: 32px;
  background: #3b87ff;
  border-radius: 2px;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  margin: 0 auto;
}
</style>